import { render, staticRenderFns } from "./TenantRestoreDialog.vue?vue&type=template&id=cad37b66&scoped=true"
import script from "./TenantRestoreDialog.vue?vue&type=script&lang=ts"
export * from "./TenantRestoreDialog.vue?vue&type=script&lang=ts"
import style0 from "./TenantRestoreDialog.vue?vue&type=style&index=0&id=cad37b66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad37b66",
  null
  
)

export default component.exports